import { scanDocumentLine, scanPiecePrice, scanTotal } from '@/lib/scanQuantity';

export const SCAN_STORAGE_KEY = 'snel_scan_state_v1';
export const SCAN_PATH = '/leveringsbonnen/snel-scan';
export const cashScanPath = id => `${SCAN_PATH}?dagontvangst=${encodeURIComponent(id)}`;
export const readScanDraft = () => {
  try { return JSON.parse(localStorage.getItem(SCAN_STORAGE_KEY)) || null; } catch { return null; }
};
const view = item => JSON.stringify(['art_id', 'art_code', 'omschrijving', 'aantal', 'eenheid', 'eenheid_aantal', 'stuks_correctie',
  'prijs', 'prijs_per_stuk', 'korting', 'korting_mode', 'btw', 'variant_combo_key', 'variant_label', 'eenheid_label'].map(k => item[k]));
const precise = value => Number(Number(value).toPrecision(15));

export const cashLineToScan = (line, index = 0) => {
  const partial = Number(line.scan_stuks_per_pack) > 0;
  const size = partial ? Number(line.scan_stuks_per_pack) : Number(line.eenheid_aantal) || 1;
  const total = partial ? Number(line.aantal) : Number(line.aantal) * size;
  const count = partial || total < 0 ? Math.max(1, Math.floor(Math.abs(total) / size)) : Number(line.aantal);
  const item = {
    _key: `cash-${line.regel_id || crypto.randomUUID()}`, cash_regel_id: line.regel_id || crypto.randomUUID(), cash_edit: true,
    art_id: line.art_id || '', art_code: line.referentie || '', omschrijving: line.omschr,
    aantal: count, eenheid: line.eenheid || 'st', eenheid_aantal: size, artikel_pack_grootte: size,
    stuks_correctie: precise(total - count * size), stuks_effectief: size,
    prijs: Number(line.prijs), prijs_per_stuk: partial,
    korting: line.scan_korting_mode === 'euro' ? Number(line.scan_korting_euro) : Number(line.korting || 0),
    korting_mode: line.scan_korting_mode || 'percent', btw: Number(line.btw), btw_handmatig: true,
    variant_code: line.combo_key || '', variant_combo_key: line.combo_key || '', variant_label: line.variant_label || '',
    eenheid_label: line.eenheid_label || '', referentie_handmatig: true, ean: '', last_scan_at: -index,
  };
  // Only strip suffixes that this formatter demonstrably added; keep custom descriptions intact.
  const suffix = scanDocumentLine({ ...item, omschrijving: '', variant_label: '' }).omschr;
  if (suffix && item.omschrijving.endsWith(suffix)) item.omschrijving = item.omschrijving.slice(0, -suffix.length);
  // The server also writes '(N stuks)', even for an exact number of whole packs.
  // Recognize only its quantity suffix (and the known scanner grammar), with matching quantity.
  if (partial || total < 0) {
    const number = '-?\\d+(?:[.,]\\d+)?(?:e[+-]?\\d+)?';
    const generated = new RegExp(`\\s\\((${number}) stuks?(?:; (?:${number} × ${number}(?:, ${number} stuks? (?:tekort|extra))?|bedragcorrectie))?\\)$`, 'i');
    const match = generated.exec(item.omschrijving);
    if (match && Number(match[1].replace(',', '.')) === total) item.omschrijving = item.omschrijving.slice(0, match.index);
  }
  const variantSuffix = item.variant_label ? ` · ${item.variant_label}` : '';
  if (variantSuffix && item.omschrijving.endsWith(variantSuffix)) item.omschrijving = item.omschrijving.slice(0, -variantSuffix.length);
  return { ...item, cash_original: { ...line }, cash_original_view: view(item) };
};

export const cashScanLine = (item, btwOverride) => {
  const original = item.cash_original;
  if (original && item.cash_original_view === view(item)) return { ...original };
  const mapped = scanDocumentLine(item, btwOverride);
  const sameArticle = original && original.art_id === (item.art_id || '') && (original.combo_key || '') === (item.variant_combo_key || item.variant_code || '');
  if (sameArticle && item.eenheid === (original.eenheid || 'st')) {
    // Keep the stored stock/cost unit and line id. Changing pieces must not reprice historical purchase costs.
    const basis = original.scan_stuks_per_pack ? 1 : Number(original.eenheid_aantal) || 1;
    return { ...original, referentie: mapped.referentie, omschr: mapped.omschr,
      aantal: precise(scanTotal(item) / basis), prijs: precise(scanPiecePrice(item) * basis),
      korting: mapped.korting, scan_korting_mode: mapped.scan_korting_mode || 'percent', scan_korting_euro: mapped.scan_korting_euro || 0,
      btw: mapped.btw, variant_label: mapped.variant_label, scan_bedragcorrectie: mapped.scan_bedragcorrectie };
  }
  return { ...mapped, regel_id: item.cash_regel_id };
};

export const receiptEditMeta = (receipt, identity, returnTo) => ({
  id: receipt.id, nummer: receipt.nummer, version: receipt.version, identity,
  original: { datum: receipt.datum, klant_id: receipt.klant_id || '', lijnen: receipt.lijnen },
  returnTo: /^\/dagontvangsten(?:\?|$)/.test(returnTo || '') ? returnTo : `/dagontvangsten?maand=${receipt.datum.slice(0, 7)}`,
});
export const cashSaveReturn = (meta, datum) => {
  const params = new URLSearchParams(meta.returnTo.split('?')[1]);
  const inRange = params.has('van') ? datum >= params.get('van') && datum <= params.get('tot') : datum.startsWith(params.get('maand') || meta.original.datum.slice(0, 7));
  return inRange ? meta.returnTo : `/dagontvangsten?maand=${datum.slice(0, 7)}`;
};